import React, {useState} from 'react';
import {Button} from '../../../components/ui/shadcn-components/button';
import {Switch} from '../../../components/ui/shadcn-components/switch';
import {NotificationLevel} from '../../data/general/notificationLevel.enum';
import {useNotification} from '../../service/notification.service';
import Title from '../../shared/layout/title/title';
import SubTitle from '../../shared/layout/subtitle/subTitle';
import TextModalPanel from '../../shared/layout/text-modal-panel/text-modal-panel';
import GenericForm from '../../shared/form/genericForm';
import {autocomplete, getUsers} from '../../service/swagger.service';
import {translate} from '../../shared/utils/localization-utils';
import {DataTable} from '../../../components/ui/DataTable/data-table';
import {TableHeaderData} from '../../data/types/tables/table-header';

interface IData {
	id: string,
	name: string,
	dateBirth: Date,
	color: string,
	amount: number,
}

interface IData2 {
	id: string,
	name: string,
	dateBirth: Date,
}

const data: IData[] = [
	{
		id: "m5gr84i9",
		name: "Claudio",
		dateBirth: new Date("2000-12-12"),
		color: "Red",
		amount: 316,
	},
	{
		id: "3u1reuv4",
		name: "Ruslan",
		dateBirth: new Date("1894-01-13"),
		color: "Black",
		amount: 216,
	},
	{
		id: "derv1ws0",
		name: "Boris",
		dateBirth: new Date("1999-05-10"),
		color: "Red",
		amount: 646,
	},
	{
		id: "bhqecj4p",
		name: "Rita",
		dateBirth: new Date("1986-06-19"),
		color: "Purple",
		amount: 782,
	},
];

const columnsData: TableHeaderData[] = [
	{
		key: "id",
		name: "Id",
		isSelector: true,
	},
	{
		key: "name",
		name: "Jméno",
		isSortable: true,
	},
	{
		key: "dateBirth",
		name: "Datum narození",
		isSortable: true,
	},
	{
		key: "color",
		name: "Oblíbená barva",
	},
	{
		key: "amount",
		name: "Částka",
		isNumberValue: true,
	},
	{
		key: "actions",
		name: "Akce",
		hasActions: true,
	},
]

const columnsData2: TableHeaderData[] = [
	{
		key: "id",
		name: "Id",
	},
	{
		key: "name",
		name: "Jméno",
		isSortable: true,
	},
	{
		key: "dateBirth",
		name: "Datum narození",
		isSortable: true,
	},
]

const data2: IData2[] = [
	{
		id: "m5gr84i9",
		name: "Claudio",
		dateBirth: new Date("2000-12-12"),
	},
	{
		id: "3u1reuv4",
		name: "Ruslan",
		dateBirth: new Date("1894-01-13"),
	},
	{
		id: "derv1ws0",
		name: "Boris",
		dateBirth: new Date("1999-05-10"),
	},
	{
		id: "bhqecj4p",
		name: "Rita",
		dateBirth: new Date("1986-06-19"),
	},
	{
		id: "qrqecj4p",
		name: "Roko",
		dateBirth: new Date("1986-12-12"),
	},
];


export function TestPage() {

	const [isModalOpen, setModalOpen] = useState(false);
	const [checked, setChecked] = useState(false);
	const {notify} = useNotification();

	const handleClick = (notificationLevel: NotificationLevel): void => {
		notify(notificationLevel, translate('error.internalServerError'));
	};

	const handleModalClose = (result: boolean): void => {
		setModalOpen(false);

		if (result) {
			console.log('Saved', result);
		} else {
			console.log('Cancelled', result);
		}
	};

	const createUserInformation = {
		nazevOrganizacniJednotky: 'priklad',
		ic: '456'
	};

	const getSwaggerUser = (): void => {
		getUsers().then();
	};

	const createSwaggerUser = (user: any): void => {
		autocomplete(user, notify).then(res => {
			console.log(res);
		});
	};

	return (
		<div className="p-6 bg-b">
			<Title keyValue={'testingPage.heading'}/>

			<SubTitle keyValue={'testingPage.subheading'}/>

			<div className="flex gap-1 mb-5 flex-wrap">
				<Button className="max-w-[218px] w-full" variant="success" onClick={() => handleClick(NotificationLevel.SUCCESS)}>Notifikace SUCCESS</Button>
				<Button className="max-w-[218px] w-full" variant="error" onClick={() => handleClick(NotificationLevel.ERROR)}>Notifikace ERROR</Button>
				<Button className="max-w-[218px] w-full" variant="warning" onClick={() => handleClick(NotificationLevel.WARNING)}>Notifikace WARNING</Button>
				<Button className="max-w-[218px] w-full" variant="info" onClick={() => handleClick(NotificationLevel.INFORMATION)}>Notifikace INFORMATION</Button>
			</div>

			<SubTitle keyValue={'testingPage.modal'}/>

			<div>
				<Button className="" variant="secondary" onClick={() => setModalOpen(true)}>Otevrit modal</Button>
				<TextModalPanel title={'testingPage.textModalHeading'}
								open={isModalOpen}
								confirmLabel={'buttonSave'}
								cancelLabel={'buttonClose'}
								textValue={'Soufflé gingerbread lemon drops sweet cookie bear claw toffee cupcake. Jelly-o croissant carrot cake marshmallow cake sweet candy canes. Shortbread lemon drops soufflé chocolate cake tart macaroon candy oat cake. Jelly candy canes sweet bear claw dessert tootsie roll cheesecake pudding lemon drops. Cookie donut bonbon cheesecake brownie cookie cake. Sweet jelly beans cupcake soufflé chupa chups dessert. Gingerbread cupcake candy canes toffee wafer donut. Macaroon pie marzipan pastry shortbread. Shortbread cupcake liquorice jelly-o toffee tiramisu muffin lemon drops bear claw. Bear claw sweet roll brownie apple pie apple pie lollipop shortbread pudding. Cheesecake wafer halvah cake icing cake chocolate bar chocolate. Carrot cake sweet roll dragée sugar plum chocolate cake sugar plum. Soufflé cotton candy apple pie dessert marzipan oat cake gingerbread cookie'}
								onClose={handleModalClose}></TextModalPanel>
			</div>

			<GenericForm/>

			<SubTitle keyValue={'testingPage.subheading.swagger'}/>

			<Button className="" variant="default" onClick={() => getSwaggerUser()}>Push me</Button>
			<Button className="" variant="default" onClick={() => createSwaggerUser(createUserInformation)}>Push me create user</Button>
			<div className="mt-6">
				<Switch
					checked={checked}
					onCheckedChange={(state) => setChecked(state)}
				/>
				<p className={`text-[12px] ${checked ? 'text-green-600' : 'text-red-600'}`}>
					{checked ? 'Posouvátko musí být posunuté' : 'Povinné (Posouvátko musí být posunuté)'}
				</p>
			</div>
			<DataTable columnsData={columnsData} data={data} hasFullTextSearch={true} />
			<DataTable columnsData={columnsData2} data={data2} />
		</div>
	);
}
